module.exports = __webpack_public_path__ + "static/media/marko-nikolajevic-logo.6bb0a3cf.svg";